import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../../lib/api";
import { PageHero } from "../../components/public/Section";
import { Calendar, MapPin, Clock, ArrowLeft, ExternalLink } from "lucide-react";

export default function EventDetail() {
  const { slug } = useParams();
  const [e, setE] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/events/${slug}`).then((r) => setE(r.data)).catch(() => setNotFound(true));
  }, [slug]);
  if (notFound) return <div className="section container-page text-center text-brand-muted">Event not found. <Link to="/events" className="text-brand-primary font-semibold">View all</Link></div>;
  if (!e) return <div className="section container-page text-center text-brand-muted">Loading…</div>;
  const d = new Date(e.event_date);
  return (
    <div>
      <PageHero title={e.title} breadcrumbs={["Home", "Events"]} />
      <section className="section container-page grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          {e.banner && <img src={e.banner} alt={e.title} className="rounded-2xl w-full shadow-card mb-8" />}
          <h2 className="font-serif text-2xl font-bold text-brand-text">About the Event</h2>
          <p className="text-brand-muted mt-3 leading-relaxed whitespace-pre-line">{e.description}</p>
          <Link to="/events" className="btn-ghost mt-8"><ArrowLeft size={16} /> Back to events</Link>
        </div>
        <aside className="space-y-4">
          <div className="card-elev p-6">
            <div className="text-xs uppercase tracking-widest text-brand-primary font-semibold">Event Details</div>
            <div className="mt-4 space-y-3 text-sm text-brand-text">
              <div className="flex items-start gap-3"><Calendar size={16} className="text-brand-primary mt-0.5" /><span>{d.toLocaleDateString(undefined, { weekday: "long", year: "numeric", month: "long", day: "numeric" })}</span></div>
              <div className="flex items-start gap-3"><Clock size={16} className="text-brand-primary mt-0.5" /><span>{e.event_time}</span></div>
              <div className="flex items-start gap-3"><MapPin size={16} className="text-brand-primary mt-0.5" /><span>{e.venue}</span></div>
            </div>
            {e.registration_link && <a href={e.registration_link} target="_blank" rel="noreferrer" className="btn-primary mt-6 w-full">Register Now <ExternalLink size={16} /></a>}
          </div>
        </aside>
      </section>
    </div>
  );
}
